import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';

import {
  VerticalScrollBodyTable,
  renderToolTip,
} from './VerticalScrollBodyTable';
import { ErrorIcon } from '../icons/ErrorIcon';
import { DATE_TIME_FORMAT } from '../../utilities/constants';
import { isNullOrUndefinedOrEmptyStr } from '../../utilities/stringUtil';
import { validExpirationDateReturnSimpleMessage } from '../../utilities/dateSelectorUtility';

export const CompanyOtherIndustryLicenseTable = ({
  data = [],
  readOnly = false,
  errorColumn = false,
  onEdit,
  onDelete,
  onDownloadFile,
  documentCodes = [],
}) => {
  const [headerColumns, setHeaderColumn] = useState([]);
  const [bodyColumns, setBodyColumn] = useState([]);

  const getColumn = columns => {
    if (readOnly) {
      columns.pop();
    }
    if (!errorColumn) {
      columns.shift();
    }
    return columns;
  };

  useEffect(
    () => {
      const _headerColumns = [
        { id: 'error', text: '', style: { width: 50 } },
        { id: 'authorized_industry_names', text: '許可業種' },
        { id: 'permission_number_r', text: '許可番号 固有番号' },
        {
          id: 'license_update_date',
          text: '許可（更新）年月日',
          style: { width: 160 },
        },
        {
          id: 'license_limit_date',
          text: '有効期限年月日',
          style: { width: 160 },
        },
        { id: 'company_documents', text: '添付書類' },
        { id: 'edit_and_delete', text: '', style: { width: 120 } },
      ];

      const renderAttachment = ({ company_documents = [] }) => (
        <ul>
          {company_documents.map(file => {
            const {
              id,
              file_name,
              file_typeS,
              temp_file_key,
              created_at,
            } = file;
            const className = id ? 'btn-text' : 'btn-text btn--no-action';
            const documentType = _.find(documentCodes, code => {
              return code.file_typeS === file_typeS;
            });
            const fileType = documentType ? documentType.file_typeS_name : '';
            let dateTimeString = '';
            const spaceJapan = '　';
            if (!_.isUndefined(created_at)) {
              const createAt = moment(created_at);
              dateTimeString = createAt.isValid()
                ? `${spaceJapan}(${createAt.format(
                    DATE_TIME_FORMAT.slashDateTimeFormat
                  )})`
                : '';
            }
            const content = `${fileType}${spaceJapan}${file_name}${dateTimeString}`;
            return (
              <li key={id || temp_file_key}>
                <button
                  className={className}
                  onClick={() => id && onDownloadFile(id)}
                >
                  {renderToolTip(content)}
                </button>
              </li>
            );
          })}
        </ul>
      );

      const _bodyColumns = [
        {
          id: 'error',
          render({ invalid_flag }) {
            if (invalid_flag) {
              return <ErrorIcon className='icon--1_4x form-list__error-icon' />;
            }
          },
          className: 'value-table__error',
          style: { width: 50 },
        },
        {
          id: 'authorized_industry_names',
          valueString: 'authorized_industry_names',
          className: 'value-table__authorized-industry-names',
        },
        {
          id: 'permission_number_r',
          valueString: 'permission_number_r',
          className: 'value-table__permission-number-r',
        },
        {
          id: 'license_update_date',
          valueString: 'license_update_date',
          style: { width: 160 },
          useTooltip: false,
        },
        {
          id: 'license_limit_date',
          render(data) {
            const licenseLimitDate = _.get(data, 'license_limit_date');
            let expireMessage = null;
            if (isNullOrUndefinedOrEmptyStr(licenseLimitDate) === false) {
              expireMessage = validExpirationDateReturnSimpleMessage(licenseLimitDate, true);
            }
            return (
              <React.Fragment>
                {_.get(data, 'license_limit_date')}
                {isNullOrUndefinedOrEmptyStr(expireMessage) === false && (
                  <p className='form-list__alert show'>（{expireMessage}）</p>
                )}
              </React.Fragment>
            );
          },
          style: { width: 160 },
        },
        {
          id: 'company_documents',
          render: renderAttachment,
        },
        {
          id: 'edit_and_delete',
          render(data) {
            return (
              <div className='action-list'>
                <button
                  className='btn--sm btn--edit'
                  onClick={() => _.isFunction(onEdit) && onEdit(data)}
                >
                  編集
                </button>
                <button
                  className='btn--sm--negative'
                  onClick={() => _.isFunction(onDelete) && onDelete(data)}
                >
                  削除
                </button>
              </div>
            );
          },
          style: { width: 120 },
        },
      ];

      setHeaderColumn(getColumn(_headerColumns));
      setBodyColumn(getColumn(_bodyColumns));
    },
    [errorColumn, documentCodes, readOnly]
  );

  return (
    <VerticalScrollBodyTable
      headerColumns={headerColumns}
      bodyColumns={bodyColumns}
      tableClassName='OtherIndustryLicenseTable'
      emptyDataClassName={readOnly ? '' : 'table__message--attention'}
      bodyStyle={{ maxHeight: 250 }}
      data={data}
      readOnly={readOnly}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/CompanyOtherIndustryLicenseTable.jsx